"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var BASE_URL = 'pipelines/v2/pipelines';

var PipelinesAPI =
/*#__PURE__*/
function () {
  function PipelinesAPI() {
    (0, _classCallCheck2.default)(this, PipelinesAPI);
  }

  (0, _createClass2.default)(PipelinesAPI, null, [{
    key: "getPipelines",
    value: function getPipelines() {
      return _apiClient.default.get(BASE_URL);
    }
  }]);
  return PipelinesAPI;
}();

exports.default = PipelinesAPI;
module.exports = exports.default;